import config from 'config';

import { setRoutesList } from 'router/helpers';

export const setParamsToWindow = () => {
    setRoutesList();

    window.HIDE_FRONT_CHAT = config.HIDE_FRONT_CHAT;
};
